module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-logo-ships-1d4d76ccc4f3f74d147962bc8f339275.png";